import "./index.css";
import { Toaster } from "react-hot-toast";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <>
    <Toaster position="top-right" reverseOrder={false} />
    <App />
  </>
  // </React.StrictMode>
);

reportWebVitals();
